/**
 * @module services/health-conversation-task
 * @description CRUD de HealthConversationTask. Mismo patrón que
 *              patient-task / treatment-task (genérico) pero específico
 *              para este tipo. El task NO es polimórfico con CheckinTask;
 *              vive en una colección propia.
 */
import api from "./api";

const healthConversationTaskService = {
  /**
   * @description Crea task. Si solo viene `templateKey`, la API hidrata
   *              defaults desde la plantilla.
   * @param {'treatment'|'patient'} entity
   * @param {Object} payload
   * @returns {Promise<Object>}
   */
  create(entity, payload) {
    return api.post(`/tasks/healthConversations/type/${entity}`, payload);
  },

  /**
   * @description Lista tasks. Pacientes ven las suyas; otros roles con permiso.
   * @param {'treatment'|'patient'} entity
   * @param {Object} [params] - filtros (patient, treatment, scheduledAt, etc.)
   * @returns {Promise<Object>} { docs, total, limit, ... }
   */
  list(entity, params = {}) {
    return api.get(`/tasks/healthConversations/type/${entity}`, { params });
  },

  /**
   * @description Histórico de tasks completadas.
   * @param {'treatment'|'patient'} entity
   * @param {Object} [params]
   * @returns {Promise<Object>}
   */
  history(entity, params = {}) {
    return api.get(`/tasks/healthConversations/type/${entity}/history`, {
      params,
    });
  },

  /**
   * @description Detalle de 1 task.
   * @param {'treatment'|'patient'} entity
   * @param {string} id
   * @returns {Promise<Object>}
   */
  get(entity, id) {
    return api.get(`/tasks/healthConversations/type/${entity}/${id}`);
  },

  /**
   * @description Edita task. No permite cambiar organization/treatment/patient
   *              ni los campos snapshot (los maneja el dispatcher).
   * @param {'treatment'|'patient'} entity
   * @param {string} id
   * @param {Object} payload
   * @returns {Promise<void>}
   */
  update(entity, id, payload) {
    return api.put(`/tasks/healthConversations/type/${entity}/${id}`, payload);
  },

  /**
   * @description Borra task. Si entity='treatment' también borra las patient
   *              futuras sin completar.
   * @param {'treatment'|'patient'} entity
   * @param {string} id
   * @returns {Promise<void>}
   */
  remove(entity, id) {
    return api.delete(`/tasks/healthConversations/type/${entity}/${id}`);
  },
};

export default healthConversationTaskService;
